export default __webpack_public_path__ + "static/media/icon_lealtad.0023012c.png";